import { Flex, FlexProps } from '@bitrise/bitkit';
import React, { ReactNode, FunctionComponent } from 'react';
import PageContent from './PageContent';

interface Props extends FlexProps {
  children: ReactNode;
}

const PageHeader: FunctionComponent<Props> = (props) => {
  const { children, ...rest } = props;

  return (
    <Flex paddingVertical="x5" {...rest} backgroundColor="white">
      <PageContent>{children}</PageContent>
    </Flex>
  );
};

export default PageHeader;
